import React from "react";
import { payoutUi } from "./payoutDesignSystem";

function PayoutEmptyState({
  icon,
  title,
  description,
  action,
  secondaryAction,
}: {
  icon: React.ReactNode;
  title: string;
  description: string;
  action?: React.ReactNode;
  secondaryAction?: React.ReactNode;
}) {
  return (
    <div className={payoutUi.emptyState.wrapper}>
      <div className={payoutUi.emptyState.icon}>{icon}</div>
      <h3 className={payoutUi.emptyState.title}>{title}</h3>
      <p className={payoutUi.emptyState.description}>{description}</p>
      {(action || secondaryAction) && (
        <div className={payoutUi.emptyState.actions}>
          {action}
          {secondaryAction}
        </div>
      )}
    </div>
  );
}

export default PayoutEmptyState;
